
export const fetchPaymentSuccess = paymentData => ({
    type: 'FETCH_ALL_PAYMENT',
    payload: { paymentData }
})


